import { createTimeIntervals } from '@/utils'
import { IOption } from '@/types'

export const times: IOption<string>[] = createTimeIntervals()

export const driverAges: IOption<string>[] = new Array(5)
  .fill(0)
  .map((_, idx) => {
    const age = 21 + idx
    const suffix = age > 24 ? '+' : ''
    const label = `${age}${suffix}`
    return { label, value: `${age}` }
  })
